<template>
  <div class="printing-headline-root">
    <div class="printing-headline-line" />

    <h2 class="printing-headline-title">
      {{ title }}
    </h2>

    <div class="printing-headline-line" />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.printing-headline-root {
  display: flex;
  padding: 10px 0;
  align-items: center;

  .printing-headline-title {
    margin: 0 20px;
  }

  .printing-headline-line {
    flex: 1;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.5);
  }
}
</style>
